import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrintReciptRoutingModule } from './print-recipt-routing.module';
import { PrintReciptComponent } from './print-recipt.component';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import { ControlsModule } from 'src/app/shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PrintRecipt2Component } from './print-recipt2/print-recipt2.component';
import { PrintRecipt3Component } from './print-recipt3/print-recipt3.component';
import { PrintRecipt4Component } from './print-recipt4/print-recipt4.component';
import { DeliveryReportComponent } from './delivery-report/delivery-report.component';
import { DeliveryReportBulkComponent } from './delivery-report-bulk/delivery-report-bulk.component';


@NgModule({
  declarations: [
    PrintReciptComponent,
    PrintRecipt2Component,
    PrintRecipt3Component,
    PrintRecipt4Component,
    DeliveryReportComponent,
    DeliveryReportBulkComponent
  ],
  imports: [
    CommonModule,
    PrintReciptRoutingModule,
    ControlsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ReusableModule,
  ]
})
export class PrintReciptModule { }
